import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Button from '../Button/Button';
import { NOOP } from '../../../utils/const';
import NavDropdown from '../../NavDropdown';
import MenuUffici from './MenuUffici';
import PermIdentityIcon from '../../GoogleIcons/Outlined/PermIdentityIcon';
import ExportIcon from '../../GoogleIcons/Outlined/ExportIcon';

const MenuUtente = ({
  utente, uffici, ufficioSelezionato, onUfficioChange, accountsUrl, myCgnUrl, onLogout, children,
}) => {
  const denominazioneUtente = utente ? `${utente.nome} ${utente.cognome}`.toUpperCase() : undefined;

  const urlLogout = `${accountsUrl}/home/logout`;

  const gotoProfiloUtente = useCallback(() => {
    window.open(`${myCgnUrl}/#/ufficio/${ufficioSelezionato}`, '_blank').focus();
  }, [myCgnUrl, ufficioSelezionato]);

  const logOut = useCallback(() => {
    window.location.replace(urlLogout);
  }, [urlLogout]);

  return (
    <NavDropdown
      className="v2-menu-utente"
      title={denominazioneUtente}
      subtitle={ufficioSelezionato ? `Ufficio ${ufficioSelezionato}` : undefined}
    >
      {children}
      <MenuUffici
        uffici={uffici}
        ufficioSelezionato={ufficioSelezionato}
        onUfficioChange={onUfficioChange}
      />
      {uffici && uffici.length > 0 && <MenuUtente.Item divider />}
      <MenuUtente.Item
        disabled={!myCgnUrl}
        onClick={gotoProfiloUtente}
      >
        <Button>
          <PermIdentityIcon /> Profilo personale
        </Button>
      </MenuUtente.Item>
      <MenuUtente.Item divider />
      <MenuUtente.Item
        onClick={() => (onLogout ? onLogout(urlLogout) : logOut())}
        disabled={!accountsUrl}
      >
        <Button>
          <ExportIcon /> Esci
        </Button>
      </MenuUtente.Item>
    </NavDropdown>
  );
};

MenuUtente.Item = NavDropdown.Item;

MenuUtente.propTypes = {
  /**
   * Informazioni sull'utente corrente (Nome e Cognome)
   */
  utente: PropTypes.shape({
    nome: PropTypes.string,
    cognome: PropTypes.string,
  }).isRequired,
  /**
   * Elenco degli uffici associati al profilo dell'utente corrente
   */
  uffici: PropTypes.arrayOf(PropTypes.string),
  /**
   * Ufficio corrente selezionato
   */
  ufficioSelezionato: PropTypes.string,
  /**
   * Callback chiamata alla selezione di un nuovo ufficio:
   * ```
   *  onUfficioChange(ufficio)
   * ```
   */
  onUfficioChange: PropTypes.func,
  /**
   * Url dell'applicazione account
   */
  accountsUrl: PropTypes.string,
  /**
   * Url dell'applicazione myCgn
   */
  myCgnUrl: PropTypes.string,
  /**
   * Elementi aggiuntivi da mostrare all'interno del menu utente usando sempre il componente NavDropdown.Item
   */
  children: PropTypes.node,
  /**
   * Funzione alternativa da applicare al click del logout
   */
  onLogout: PropTypes.func,
};

MenuUtente.defaultProps = {
  uffici: [],
  ufficioSelezionato: null,
  accountsUrl: null,
  myCgnUrl: null,
  onUfficioChange: NOOP,
  children: null,
  onLogout: null,
};

export default MenuUtente;
